<template>
	   <div class="mdc-card mgt-24 pdt-24 pdb-16 pdl-24 pdr-24" v-if="listData && fillInTheRange">
					<div class="t-color4 t-color-bodyGrayA l-spacing36 font-r t-body3">{{ $t('1958')}}</div>
					<div class="mgt-8 mgb-16 font-m t-subtitle3">
						<vue-mathjax :formula="listData.question.contents" v-if="listData.question.useMathjax"></vue-mathjax>
						<div v-else>
							{{ listData.question.contents }}
						</div>
					</div>
					<div v-if="listData.question.image">
						<img class="round mgb-8" :src="listData.question.image.resourceUri" alt="" v-if="listData.question.image">
				</div>
				<div class="question-choices">
								<div class="t-body3 t-color-bodyGrayA mgt-16"><span>{{fillInTheRange.min}}-{{fillInTheRange.max}}</span></div>
				</div>

				<div class="question-choices">
								<div class="t-body2 mgt-16 pdt-8" style="color: var(--HeadlineBlack) !important;" >
												{{fillInTheRange.correct ? $t('1270') : $t('1271')}}
								</div>
								<!-- <div class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full mgt-4" :id="`answerEl`">
												<input type="text" class="mdc-text-field__input"
																maxlength="50"
																autocomplete="off"
																v-model="textAnswer"
																readonly
												>
												<div class="mdc-notched-outline">
																<div class="mdc-notched-outline__leading"></div>
																<div class="mdc-notched-outline__notch">
																</div>
																<div class="mdc-notched-outline__trailing"></div>
												</div>
								</div> -->
				<label
						class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46 "
						data-mdc-auto-init="MDCTextField"
							>
				<span class="mdc-notched-outline">
					<span class="mdc-notched-outline__leading"></span>
					<span class="mdc-notched-outline__notch">
				<!-- <span class="mdc-floating-label" id="my-label-id">	{{fillInTheRange.correct ? $t('1270') : $t('1271')}}</span> -->
					</span>
					<span class="mdc-notched-outline__trailing"></span>
				</span>
				<input class="mdc-text-field__input" type="text" aria-labelledby="my-label-id"
						maxlength="50"
						autocomplete="off"
						v-model="textAnswer"
						readonly
				/>
			</label>
								<div v-if="!fillInTheRange.correct" class="mgt-16">
												<hr class="divider">
												<div class="t-body2 mgt-16" style="color: var(--HeadlineBlack) !important;">
																{{$t('1272')}}
																<!-- Check the right answer! -->
												</div>
												<div class="t-body2 bg-quizGray b-radius4 pdr-24 mgt-8 mgb-8">
																<div class="t-body1 choice pdt-8 pdb-8">
																				<div class="mgr-16 mgl-16" style="color: var(--HeadlineBlack) !important;">
																								<span>{{textCorrect}}</span>
																				</div>
																</div>
												</div>
								</div>
				</div>
				</div>
</template>

<script>
/**
 * 범위입력형 문항 피드백 컴포넌트(fill in the range type question feedback component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define

import {questionMixin} from '@/mixins/question.js'

export default {
	props: ['listData', 'fillInTheRange'],
	data() {
		return {
			textAnswer: '',
			textCorrect: '',
			questionImage:null
		}
	},
	

	mixins: [questionMixin],

	mounted() {
		this.textAnswer = Math.floor(this.fillInTheRange.textAnswer)
		let temp = this.fillInTheRange.textCorrect?this.fillInTheRange.textCorrect.split('-'):[];
		this.textCorrect =temp.map(val=>Math.floor(val)).join('-')
		const textField = new MDCTextField(document.getElementById(`answerEl`))

		if(this.listData && this.listData.question && this.listData.question.image) {
			let getImage = this.listData.question.image.resourceUri.split('default_thumnail_en.jpg')
			if(getImage[1] !=''){
				this.questionImage = this.listData.question.image.resourceUri;
			} else {
				this.questionImage = null
			}
		}
	},
}
</script>
